module.exports = __webpack_public_path__ + "templates/calendar-booking_success.html";


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/booking/templates/calendar-booking_success.html
// module id = tbzg
// module chunks = 1